// Clueless v2 comp interactions. Comp only; cart wiring lands in the Shopify build.

// Header goes solid once the hero has scrolled past
(function () {
  var hdr = document.getElementById('hdr');
  if (!hdr || !hdr.classList.contains('over')) return;
  var hero = document.querySelector('.hero');
  if (!hero) return;
  function sync() {
    var past = window.scrollY > (hero.offsetHeight - hdr.offsetHeight - 8);
    hdr.classList.toggle('over', !past);
  }
  sync();
  window.addEventListener('scroll', sync, {passive: true});
})();

// Wishlist toggle
document.addEventListener('click', function (e) {
  var w = e.target.closest('.wish');
  if (!w) return;
  e.preventDefault();
  w.setAttribute('aria-pressed', w.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
});

// Newsletter validation
(function () {
  var form = document.querySelector('.nlt form');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var box = form.closest('.nlt');
    var v = form.querySelector('input').value;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { box.classList.add('bad'); return; }
    box.classList.remove('bad');
    form.querySelector('button').textContent = 'Done';
  });
})();

// Size selection
(function () {
  var group = document.querySelector('.sizes');
  if (!group) return;
  group.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    group.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    b.setAttribute('aria-pressed', 'true');
  });
})();

// Quantity stepper, keeps the add-to-cart total in sync
(function () {
  var qty = document.querySelector('.qty');
  if (!qty) return;
  var out = qty.querySelector('output');
  var atc = document.querySelector('.atc');
  qty.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    var n = Math.min(10, Math.max(1, parseInt(out.textContent, 10) + parseInt(b.dataset.d, 10)));
    out.textContent = n;
    // Unit price comes from the button, not a hardcoded tee price — hoodies are
    // 1199 and joggers 1299, so qty 2 was showing the wrong total on five PDPs.
    if (atc) {
      if (!atc.dataset.price) {
        var seed = parseInt(atc.textContent.replace(/[^0-9]/g, ''), 10);
        atc.dataset.price = String(seed || 999);
      }
      var unit = parseInt(atc.dataset.price, 10) || 999;
      atc.innerHTML = 'Add to cart · ₹' + (unit * n).toLocaleString('en-IN');
    }
  });
})();

// Pincode delivery check: region from the PIN, window from theme settings (Keshav's
// sheet, 21 Sep 2026: West 3-4, North 3-5, South 3-5, East 5, remote 5-7+).
// India Post zones by first digit: 1-2 North, 3-4 West, 5-6 South, 7-8 East, 9 Army.
// Remote: J&K and Ladakh (18x-19x), the North East (78x-79x), Sikkim (737), Andaman (744),
// Lakshadweep (682 5xx), Army post (9xxxxx).
(function () {
  var pin = document.getElementById('pin');
  if (!pin) return;
  var input = pin.querySelector('input');
  var out = pin.querySelector('.out');
  function region(p) {
    var d1 = p.charAt(0), d2 = p.slice(0, 2), d3 = p.slice(0, 3);
    if (d1 === '9' || d2 === '18' || d2 === '19' || d2 === '78' || d2 === '79' || d3 === '737' || d3 === '744' || (d3 === '682' && p.charAt(3) === '5')) return 'remote';
    if (d1 === '1' || d1 === '2') return 'north';
    if (d1 === '3' || d1 === '4') return 'west';
    if (d1 === '5' || d1 === '6') return 'south';
    return 'east';
  }
  var label = { north: 'North', west: 'West', south: 'South', east: 'East', remote: 'Remote area' };
  pin.querySelector('button').addEventListener('click', function () {
    pin.classList.add('done');
    var p = input.value.trim();
    if (/^[1-9][0-9]{5}$/.test(p)) {
      var r = region(p);
      var eta = pin.getAttribute('data-eta-' + r) || '4 to 6 days';
      out.classList.remove('err');
      out.textContent = 'Delivery to ' + p + ' (' + label[r] + '): ' + eta + '. Dispatched within 72 hours. Free shipping.';
    } else {
      out.classList.add('err');
      out.textContent = 'Enter a valid 6-digit pincode.';
    }
  });
})();

// Offer codes: Copy puts the code on the clipboard, Apply saves it for checkout the way the
// cart drawer's coupon field does (sessionStorage cl_coupon, /discount/CODE on checkout).
(function () {
  function flash(c, text) { var b = c.querySelector('.osc-copy') || c; var t = b.textContent; b.textContent = text; c.classList.add('did'); setTimeout(function () { b.textContent = t; c.classList.remove('did'); }, 1600); }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-copy]');
    if (c) {
      var code = c.getAttribute('data-copy');
      var done = function () { flash(c, 'Copied'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
      else { var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (x) {} document.body.removeChild(ta); done(); }
      return;
    }
    var a = e.target.closest('[data-apply]');
    if (a) {
      var v = a.getAttribute('data-apply');
      try { window.sessionStorage.setItem('cl_coupon', v); } catch (x) {}
      var input = document.getElementById('coupon'); if (input) input.value = v;
      document.dispatchEvent(new CustomEvent('cl:coupon:set', { detail: { code: v } }));
      flash(a, 'Applied');
    }
  });
})();

// Gallery lightbox
(function () {
  var lb = document.getElementById('lb');
  if (!lb) return;
  var img = lb.querySelector('img');
  var last = null;
  document.querySelectorAll('#gal figure').forEach(function (f) {
    f.setAttribute('tabindex', '0');
    f.setAttribute('role', 'button');
    var src = f.querySelector('img');
    f.setAttribute('aria-label', 'Zoom: ' + src.alt);
    function open() {
      img.src = src.src; img.alt = src.alt; last = f;
      lb.classList.add('on');
      lb.querySelector('button').focus();
    }
    f.addEventListener('click', open);
    f.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  });
  function close() { lb.classList.remove('on'); if (last) last.focus(); }
  lb.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

// Mobile sticky buy bar appears once the buy row scrolls away
(function () {
  var bar = document.getElementById('mbar');
  var anchor = document.querySelector('.buyrow');
  if (!bar || !anchor || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    bar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
  }).observe(anchor);
})();

/* ============================================================
   v3 additions: side menu, bottom cart, size guide.
   Everything opens on click only. There is no popup, no modal
   on load and no exit-intent overlay anywhere on this site (C25).
   ============================================================ */

// Shared open/close for the panels
function panel(openerSel, panelId, scrimId, closeSel) {
  var opener = document.querySelector(openerSel);
  var el = document.getElementById(panelId);
  var scrim = document.getElementById(scrimId);
  if (!el || !scrim) return null;
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('on'); el.classList.add('on'); });
    el.setAttribute('aria-hidden', 'false');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input');
    if (f) f.focus();
  }
  function close() {
    scrim.classList.remove('on');
    el.classList.remove('on');
    el.setAttribute('aria-hidden', 'true');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { scrim.hidden = true; }, 260);
    if (lastFocus) lastFocus.focus();
  }
  if (opener) opener.addEventListener('click', open);
  scrim.addEventListener('click', close);
  el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el.classList.contains('on')) close();
  });
  return { open: open, close: close };
}

panel('#menubtn', 'sidenav', 'navscrim', '.sn-close');
var cartPanel = panel('#cartbtn', 'cartbar', 'cartscrim', '.cb-close');

// Add to cart opens the bottom cart, so the shipping line and coupon are seen
// before checkout rather than on the Shopify checkout page (C21, C22).


/* ============================================================
   Shopify cart. The comp's session-only cart (fake add, DOM-counted totals, coupon and
   checkout stubs) is gone from this copy. The product section posts the form to
   /cart/add.js and fires cl:cart:added; the cart-drawer section owns the drawer (CLCart:
   refresh from the Section Rendering API, remove via /cart/change.js, coupon handed to
   checkout through /discount/CODE). This block joins the two and adds Quick add.
   ============================================================ */
(function () {
  function refreshAndOpen(sections) {
    document.dispatchEvent(new CustomEvent('cl:cart:changed', { detail: { sections: sections } }));
  }
  // The product section redirects to /cart unless someone claims the add. We claim it.
  document.addEventListener('cl:cart:added', function (e) {
    e.preventDefault();
    var r = e.detail && e.detail.response;
    refreshAndOpen(r && r.sections);
  });
  // Quick add on a card: the variant the snippet chose (M when it exists), quantity 1.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.qadd');
    if (!b) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-variant'), 10);
    var url = b.getAttribute('data-url');
    if (!id) { if (url) window.location.href = url; return; }
    b.disabled = true;
    var section = window.CLCart && window.CLCart.section;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(section
        ? { items: [{ id: id, quantity: 1 }], sections: section, sections_url: window.location.pathname }
        : { items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (j) { refreshAndOpen(j && j.sections); })
      .catch(function () { if (url) window.location.href = url; })
      .then(function () { b.disabled = false; });
  });
})();

// Size guide: opens from the label and from the secondary actions, and highlights
// whichever size is currently selected on the page.
(function () {
  var sg = document.getElementById('sg');
  if (!sg) return;
  var lastFocus = null;
  function syncRow() {
    var sel = document.querySelector('.sizes button[aria-pressed="true"]');
    var want = sel ? sel.textContent.trim() : null;
    sg.querySelectorAll('tbody tr').forEach(function (tr) {
      tr.classList.toggle('on', !!want && tr.getAttribute('data-size') === want);
    });
  }
  function open() {
    lastFocus = document.activeElement;
    syncRow();
    sg.hidden = false;
    requestAnimationFrame(function () { sg.classList.add('on'); });
    document.body.style.overflow = 'hidden';
    sg.querySelector('.sg-close').focus();
  }
  function close() {
    sg.classList.remove('on');
    document.body.style.overflow = '';
    setTimeout(function () { sg.hidden = true; }, 260);
    if (lastFocus) lastFocus.focus();
  }
  document.querySelectorAll('.sg-open').forEach(function (b) { b.addEventListener('click', open); });
  sg.querySelector('.sg-close').addEventListener('click', close);
  sg.addEventListener('click', function (e) { if (e.target === sg) close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sg.classList.contains('on')) close();
  });
  var sizes = document.querySelector('.sizes');
  if (sizes) sizes.addEventListener('click', syncRow);
})();

/* --- search over the local catalogue index --- */
(function () {
  var box = document.getElementById('srch');
  if (!box || !window.CLUELESS_INDEX) return;
  var q = document.getElementById('srchq');
  var out = document.getElementById('srchr');
  var empty = document.getElementById('srche');
  var count = box.querySelector('.srch-count');
  var last = null;
  var money = function (n) { return '₹' + n.toLocaleString('en-IN'); };

  function render(term) {
    var t = term.trim().toLowerCase();
    var hits = !t ? window.CLUELESS_INDEX : window.CLUELESS_INDEX.filter(function (p) {
      return (p.n + ' ' + p.c + ' ' + p.k + ' ' + p.col).toLowerCase().indexOf(t) > -1;
    });
    out.innerHTML = hits.map(function (p) {
      return '<a class="sr-row" href="' + p.u + '">' +
        '<img src="' + p.i + '" alt="" loading="lazy">' +
        '<span><span class="sr-nm">' + p.n + '</span><span class="sr-cl">' + p.c + '</span></span>' +
        '<span class="sr-pr">' + money(p.p) + '</span></a>';
    }).join('');
    empty.hidden = hits.length > 0;
    count.textContent = t ? (hits.length + (hits.length === 1 ? ' result' : ' results')) : 'All ' + hits.length + ' pieces';
  }

  function open() { last = document.activeElement; box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('on'); });
    document.body.style.overflow = 'hidden'; render(''); q.value = ''; q.focus(); }
  function close() { box.classList.remove('on'); document.body.style.overflow = '';
    setTimeout(function () { box.hidden = true; }, 240); if (last) last.focus(); }

  document.querySelectorAll('.srch-open').forEach(function (b) { b.addEventListener('click', open); });
  box.querySelector('.srch-close').addEventListener('click', close);
  box.addEventListener('click', function (e) { if (e.target === box) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('on')) close(); });
  q.addEventListener('input', function () { render(q.value); });
  box.querySelectorAll('.srch-sugg button').forEach(function (b) {
    b.addEventListener('click', function () { q.value = b.dataset.q; render(q.value); q.focus(); });
  });
})();


// PDP "Shown on" option. Chooses which model's frames are visible. The garment is the
// same unisex piece either way, so this filters VIEWS, never variants or prices.
// Him is pre-selected server-side; the female figures ship with [hidden] already set.
(function () {
  var pick = document.querySelector('.galpick');
  var gal = document.getElementById('gal');
  if (!pick || !gal) return;
  var figs = Array.prototype.slice.call(gal.querySelectorAll('figure'));
  pick.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn) return;
    var want = btn.getAttribute('data-sex');
    // Persist from the PDP too, so the choice survives back-navigation to a grid, and tell
    // the rest of the page: the Complete the look pair and the You may also like cards
    // follow it (the swapper below listens). The PDP has no grid toggle to click.
    try { sessionStorage.setItem('cl_shown_on', want); } catch (err) {}
    document.dispatchEvent(new CustomEvent('cl:shown-on', { detail: want }));
    pick.querySelectorAll('button').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    figs.forEach(function (f) {
      if (f.getAttribute('data-sex') === want) { f.removeAttribute('hidden'); }
      else { f.setAttribute('hidden', ''); }
    });
  });
})();

/* Swap every product card between the male and female shots. Both sets ship with the
   card, so this is a src swap, not a fetch, and the hover image swaps with it. Any other
   image carrying data-src-m / data-src-w (the PDP's Complete the look pair) swaps too.
   Driven by the grid toggle (.modelpick) and by the PDP switch via 'cl:shown-on'; the
   PDP has cards but no .modelpick, so this must not bail when there is no toggle. */
(function () {
  var picks = document.querySelectorAll('.modelpick');
  var cards = Array.prototype.slice.call(document.querySelectorAll('.pcard[data-mb]'));
  var pairs = Array.prototype.slice.call(document.querySelectorAll('img[data-src-m][data-src-w]'));
  if (!picks.length && !cards.length && !pairs.length) return;
  // Card images carry a srcset (card-product.liquid), which outranks src; rebuild it from the
  // swapped URL, whose width=760 is the snippet's base. Images without a srcset just take src.
  function setSrc(img, url) {
    if (!url) return;
    if (img.hasAttribute('srcset')) {
      img.setAttribute('srcset', [360, 540, 760, 900].map(function (w) {
        return url.replace(/([?&]width=)760\b/, '$1' + w) + ' ' + w + 'w';
      }).join(', '));
    }
    img.src = url;
  }
  function apply(sex) {
    var her = sex === 'female';
    cards.forEach(function (c) {
      var main = c.querySelector('figure a img');
      var alt = c.querySelector('figure img.alt');
      if (main) setSrc(main, c.getAttribute(her ? 'data-wb' : 'data-mb'));
      if (alt) setSrc(alt, c.getAttribute(her ? 'data-wf' : 'data-mf'));
    });
    pairs.forEach(function (i) { i.src = i.getAttribute(her ? 'data-src-w' : 'data-src-m'); });
    picks.forEach(function (p) {
      p.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-sex') === sex ? 'true' : 'false');
      });
    });
  }
  picks.forEach(function (p) {
    p.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var sex = btn.getAttribute('data-sex');
      apply(sex);
      try { sessionStorage.setItem('cl_shown_on', sex); } catch (err) {}
    });
  });
  document.addEventListener('cl:shown-on', function (e) { apply(e.detail); });
  // restore the grid to whatever the visitor last chose
  var saved = null;
  try { saved = sessionStorage.getItem('cl_shown_on'); } catch (err) {}
  if (saved === 'female') apply('female');
})();

/* Warm the product page's first photos when a card is touched or hovered: the two photos the
   gallery shows first, at the gallery's own srcset and sizes, so the browser picks the same file
   and has it cached by the time the page arrives (about half a second ahead on a phone). The
   card carries the URLs (data-pfm, data-pfw at width=600, card-product.liquid). */
(function () {
  var W = [600, 900, 1100, 1600];
  var SIZES = '(min-width: 900px) 30vw, 50vw';
  var done = {}, keep = [], hov = null;
  function warm(card) {
    var her = false;
    try { her = sessionStorage.getItem('cl_shown_on') === 'female'; } catch (e) {}
    var list = (card.getAttribute(her ? 'data-pfw' : 'data-pfm') || card.getAttribute('data-pfm') || '').split(' ');
    list.forEach(function (u, i) {
      if (!u || done[u]) return;
      done[u] = 1;
      var im = new Image();
      if (i === 0) im.setAttribute('fetchpriority', 'high');
      im.sizes = SIZES;
      im.srcset = W.map(function (w) { return u.replace(/([?&]width=)600\b/, '$1' + w) + ' ' + w + 'w'; }).join(', ');
      keep.push(im);
    });
  }
  function cardOf(e) {
    var a = e.target && e.target.closest && e.target.closest('.pcard a[href*="/products/"]');
    return a ? a.closest('.pcard') : null;
  }
  ['pointerdown', 'touchstart'].forEach(function (t) {
    document.addEventListener(t, function (e) { var c = cardOf(e); if (c) warm(c); }, { passive: true, capture: true });
  });
  document.addEventListener('mouseover', function (e) {
    var c = cardOf(e); if (!c) return;
    clearTimeout(hov); hov = setTimeout(function () { warm(c); }, 90);
  }, { passive: true });
})();

/* Carry the Him/Her choice from a grid into the product page. Without this a shopper
   who switches the grid to Her, then clicks a card, lands on the male gallery — the
   defect Keshav filmed and then reproduced live on the 31 August call. */
(function () {
  var saved = null;
  try { saved = sessionStorage.getItem('cl_shown_on'); } catch (err) {}
  if (saved !== 'female') return;
  var pick = document.querySelector('.galpick');
  if (!pick) return;
  var btn = pick.querySelector('button[data-sex="female"]');
  if (btn && btn.getAttribute('aria-pressed') !== 'true') btn.click();
})();

/* Shop by look hotspots: one open at a time, click outside or Escape to close. */
(function () {
  var stage = document.querySelector('.lk-stage');
  if (!stage) return;
  function closeAll() {
    stage.querySelectorAll('.lk-pop').forEach(function (p) { p.hidden = true; });
    stage.querySelectorAll('.lk-dot').forEach(function (d) { d.setAttribute('aria-expanded', 'false'); });
  }
  stage.addEventListener('click', function (e) {
    var dot = e.target.closest('.lk-dot');
    if (!dot) return;
    var key = dot.getAttribute('data-key');
    var open = dot.getAttribute('aria-expanded') === 'true';
    closeAll();
    if (open) return;
    dot.setAttribute('aria-expanded', 'true');
    var pop = stage.querySelector('.lk-pop[data-for="' + key + '"]' +
      (dot.classList.contains('lk-m') ? '.lk-m' : '.lk-d'));
    if (pop) pop.hidden = false;
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.lk-stage')) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
})();


/* PDP secondary actions. These were href="#" anchors, so a click threw the customer
   from the buy row back to the top of the page. */
(function () {
  document.querySelectorAll('.lnk-btn[data-act="share"]').forEach(function (b) {
    b.addEventListener('click', function () {
      var data = { title: document.title, url: location.href };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      var done = function () { var t = b.textContent; b.textContent = 'Link copied'; setTimeout(function () { b.textContent = t; }, 1600); };
      if (navigator.clipboard) { navigator.clipboard.writeText(location.href).then(done, function () {}); }
    });
  });
  document.querySelectorAll('.lnk-btn[data-act="wish"]').forEach(function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') === 'true';
      b.setAttribute('aria-pressed', on ? 'false' : 'true');
      b.textContent = on ? 'Save to wishlist' : 'Saved to wishlist';
    });
  });
})();



/* What buyers say carousel: dots select, arrows and swipe step, auto-advances every
   6s and pauses on hover or focus. All seven of his reviews are in the DOM. */
(function () {
  var car = document.querySelector('.rev-car');
  if (!car) return;
  var figs = Array.prototype.slice.call(car.querySelectorAll('.rev'));
  var dots = Array.prototype.slice.call(car.querySelectorAll('.rev-dots button'));
  if (figs.length < 2) return;
  var i = 0, timer = null;
  function show(n) {
    i = (n + figs.length) % figs.length;
    figs.forEach(function (f, k) { f.hidden = k !== i; });
    dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
  }
  function start() { stop(); timer = setInterval(function () { show(i + 1); }, 6000); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
  car.addEventListener('mouseenter', stop); car.addEventListener('mouseleave', start);
  car.addEventListener('focusin', stop);    car.addEventListener('focusout', start);
  car.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { show(i + 1); start(); }
    if (e.key === 'ArrowLeft')  { show(i - 1); start(); }
  });
  var x0 = null;
  car.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  car.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); start(); }
  }, { passive: true });
  start();
})();


/* Hero slideshow: crossfades the .slide pictures, dots select, pauses on hover.
   Loading order (26 Sep 2026): cl-hero.liquid ships real URLs for the first desktop slide
   and the first phone slide only; the others carry data-src / data-srcset. They are fetched
   one at a time after window load, and go() never switches to a slide whose picture has
   not arrived: it fetches it, waits, then switches. */
(function () {
  var hero = document.querySelector('.hero-auto');
  if (!hero) return;
  var dots = hero.querySelector('.hero-dots');
  // desktop-only slides are display:none on phones; run the show on the visible ones only
  var shown = function (el) { return getComputedStyle(el).display !== 'none'; };
  var all = [].slice.call(hero.querySelectorAll('.slide'));
  var slides = all.filter(shown);
  var dotEls = dots ? [].slice.call(dots.children).filter(shown) : [];
  all.forEach(function (s) { s.classList.remove('on', 'on-m'); });
  if (dots) [].forEach.call(dots.children, function (d) { d.removeAttribute('aria-current'); });
  if (!slides.length) return;
  slides[0].classList.add('on');
  if (dotEls[0]) dotEls[0].setAttribute('aria-current', 'true');
  var every = (parseInt(hero.getAttribute('data-interval'), 10) || 5) * 1000;
  var i = 0, timer = null, want = null;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hdr = document.getElementById('hdr');
  // Put a deferred slide's real URLs in place, the <source> before the <img> so a phone never
  // selects the desktop file, then call cb once its picture has loaded or failed.
  function hydrate(s, cb) {
    var im = s.querySelector('img');
    if (!im) { if (cb) cb(); return; }
    var fresh = false;
    [].forEach.call(s.querySelectorAll('source[data-srcset]'), function (so) {
      so.setAttribute('srcset', so.getAttribute('data-srcset'));
      so.removeAttribute('data-srcset');
      fresh = true;
    });
    if (im.hasAttribute('data-srcset')) { im.setAttribute('srcset', im.getAttribute('data-srcset')); im.removeAttribute('data-srcset'); fresh = true; }
    if (im.hasAttribute('data-src')) { im.setAttribute('loading', 'eager'); im.setAttribute('src', im.getAttribute('data-src')); im.removeAttribute('data-src'); fresh = true; }
    if (!cb) return;
    if (!fresh && im.complete) { cb(); return; }
    var done = false;
    var fin = function () { if (!done) { done = true; cb(); } };
    im.addEventListener('load', fin, { once: true });
    im.addEventListener('error', fin, { once: true });
  }
  function ready(s) {
    var im = s.querySelector('img');
    return !im || (!im.hasAttribute('data-src') && im.complete);
  }
  function tone() {
    // The header is transparent over the hero; a light slide needs it in ink.
    var light = slides[i].getAttribute('data-tone') === 'light';
    if (hdr) hdr.classList.toggle('ink', light);
    hero.classList.toggle('on-light', light);   // copy, button and dots follow the header
  }
  function go(n) {
    var k = (n + slides.length) % slides.length;
    if (!ready(slides[k])) {
      // hold the current slide until the next picture is in, then switch and restart the clock
      want = k;
      hydrate(slides[k], function () { if (want === k) { want = null; go(k); if (timer) start(); } });
      return;
    }
    want = null;
    slides[i].classList.remove('on');
    if (dotEls[i]) dotEls[i].removeAttribute('aria-current');
    i = k;
    slides[i].classList.add('on');
    if (dotEls[i]) dotEls[i].setAttribute('aria-current', 'true');
    tone();
  }
  tone();
  if (slides.length < 2) return;
  // a tick never overrides a switch that is still waiting for its picture (a tapped dot wins)
  // The clock starts on the shopper's first touch, scroll or pointer move (html.moved, set in
  // theme.liquid), so the first view stays still while the page loads.
  function moved() { return document.documentElement.classList.contains('moved'); }
  function start() { stop(); if (!still && moved()) timer = setInterval(function () { if (want === null) go(i + 1); }, every); }
  function stop() { if (timer) clearInterval(timer); timer = null; }
  dotEls.forEach(function (b, k) { b.addEventListener('click', function () { go(k); start(); }); });
  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  // after load, fetch the deferred slides (visible ones only) one at a time, in order
  function queue() {
    var rest = slides.filter(function (s) { var im = s.querySelector('img'); return im && im.hasAttribute('data-src'); });
    (function next() { var s = rest.shift(); if (s) hydrate(s, next); })();
  }
  if (document.readyState === 'complete') queue(); else window.addEventListener('load', queue);
  if (moved()) start(); else document.addEventListener('cl:moved', start, { once: true });
})();

/* Reels and the about film: play muted while in view, pause when not, tap the speaker for
   sound (one reel at a time). Videos with data-src load on first sight only. */
(function () {
  var vids = [].slice.call(document.querySelectorAll('.reel-v video, .about-v video'));
  if (!vids.length) return;
  // Reels 2, 5 and 6 open on a black frame, which is what a phone shows until playback starts
  // (and for good if autoplay is blocked, e.g. Low Power Mode). A reel with data-full plays
  // its 8 s preview, which is cut past that frame; any other reel video starts at 1 s.
  function prime(v) { if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src + (v.closest('.reel-v') && !v.dataset.full ? '#t=1' : ''); } }
  // The full reel, joined at the moment the preview is showing (the preview starts data-off s in).
  function full(v, t) { if (!v.dataset.full || v.dataset.isFull) return; v.dataset.isFull = '1'; v.src = v.dataset.full + '#t=' + Math.max(0, t).toFixed(2); }
  vids.forEach(function (v) {
    if (!v.dataset.full) return;
    v.addEventListener('error', function () { if (!v.dataset.isFull) { full(v, 1); v.play().catch(function () {}); } });
  });
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && e.intersectionRatio >= 0.35) { prime(v); v.play().catch(function () {}); }
      else if (!v.paused) { v.pause(); }
    });
  }, { threshold: [0, 0.35, 0.6] }) : null;
  vids.forEach(function (v) { v.muted = true; if (io) io.observe(v); else { prime(v); v.play().catch(function () {}); } });
  // Reel posters (six JPEGs, about 430 KB) load when the rail comes within 600 px, not with
  // the page. Watching the rail, not each video, so reels scrolled sideways never show black.
  function posters(root) { root.querySelectorAll('video[data-poster]').forEach(function (v) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); }); }
  var pio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es, o) {
    es.forEach(function (e) { if (e.isIntersecting) { posters(e.target); o.unobserve(e.target); } });
  }, { rootMargin: '600px 0px' }) : null;
  document.querySelectorAll('.reels').forEach(function (r) { if (pio) pio.observe(r); else posters(r); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.reel-snd'); if (!b) return;
    var box = b.closest('.reel-v, .about-v'); var v = box && box.querySelector('video'); if (!v) return;
    var on = b.getAttribute('aria-pressed') !== 'true';
    vids.forEach(function (o) { if (o !== v) { o.muted = true; var ob = o.closest('.reel-v, .about-v'); var obtn = ob && ob.querySelector('.reel-snd'); if (obtn) { obtn.setAttribute('aria-pressed', 'false'); obtn.setAttribute('aria-label', 'Sound on'); } } });
    prime(v);
    if (on && v.dataset.full && !v.dataset.isFull) full(v, (v.currentTime || 0) + parseFloat(v.dataset.off || '0'));
    v.muted = !on; b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Sound off' : 'Sound on');
    if (on) v.play().catch(function () {});
  });
})();

// Shiprocket tracking: the AWB goes in the path, so submit opens base + number.
(function () {
  var f = document.querySelector('.track-awb');
  if (!f) return;
  f.addEventListener('submit', function (e) {
    e.preventDefault();
    var awb = (f.querySelector('input').value || '').replace(/\s+/g, '');
    if (!awb) return;
    var base = f.getAttribute('data-awb-base') || '';
    if (base && base.slice(-1) !== '/') base += '/';
    window.open(base + encodeURIComponent(awb), '_blank', 'noopener');
  });
})();

// Back from Razorpay: phones restore the page from the back/forward cache with Razorpay's
// "Processing" spinner still inside the checkout button, and nothing clears it. Reload the
// page in that case so the button and cart are fresh.
(function () {
  var KEY = 'cl_rzp_open';
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], [data-buy-now]');
    if (t) { try { sessionStorage.setItem(KEY, '1'); } catch (err) {} }
  }, true);
  window.addEventListener('pageshow', function (e) {
    var was = false;
    try { was = sessionStorage.getItem(KEY) === '1'; sessionStorage.removeItem(KEY); } catch (err) {}
    if (e.persisted && was) window.location.reload();
  });
})();

// Cart offers strip: hold the scroll while a finger is on it, and for a moment after, so a chip
// can be read and tapped on phones (hover pauses it on desktop).
(function () {
  var t = null;
  document.addEventListener('touchstart', function (e) {
    var s = e.target.closest && e.target.closest('.offers-scroll');
    if (!s) return;
    clearTimeout(t); s.classList.add('hold');
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    var s = e.target.closest && e.target.closest('.offers-scroll');
    if (!s) return;
    clearTimeout(t); t = setTimeout(function () { s.classList.remove('hold'); }, 2500);
  }, { passive: true });
})();
